import {LinkButton, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {PropsWithChildren} from 'react'

import {HTMLAnchorElementProps} from '../types'
import {variantClasses} from './HeaderButton.classes'

export type HeaderButtonProps = {
  rel?: HTMLAnchorElementProps['rel']
  target?: HTMLAnchorElementProps['target']
  href?: HTMLAnchorElementProps['href']
  variant?: 'outline' | 'pseudo' | 'fill'
  // Делает pseudo кнопку немного прозрачной
  transparent?: boolean
  // active нужен для pseudo + transparent кнопки, в случае, когда мы ходим, чтобы она оставалась активной не только во время ховера и когда хотим сами управлять ее состоянием
  active?: boolean
  size?: 's' | 'm'
  width?: 'auto' | 'full'
  onPress?: VoidFunction
  className?: string
}

export default function HeaderButton({
  children,
  variant = 'fill',
  size = 'm',
  width = 'auto',
  transparent = false,
  active = false,
  onPress,
  className,
  ...linkProps
}: PropsWithChildren<HeaderButtonProps>) {
  return (
    <LinkButton
      className={clsx(variantClasses.root, variantClasses[variant], variantClasses[width], className)}
      onPress={onPress}
      shape="circle"
      size="xs"
      variant={null}
      {...linkProps}
    >
      <Typography
        className={clsx(
          variantClasses.text,
          {[variantClasses.transparent]: transparent},
          {[variantClasses.active]: active},
        )}
        group="tight"
        thickness="regular"
        variant={size === 's' ? 'body2' : 'body1'}
      >
        {children}
      </Typography>
    </LinkButton>
  )
}
